<template>
  <div class="layer_section-container shipping_delivery_st02">
    <div class="layer-header">
      <h1 class="header-title">개인정보 수집 &#183; 이용 동의</h1>
    </div>
    <div class="layer-content shipping">
      <h2 class="busTxt">개인정보 이용 목적과 항목</h2>
      <div class="business_tbData01">
        <table>
          <colgroup>
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th>목적</th>
              <th>항목</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>대금 결제 서비스</td>
              <td>
                ABO 번호 또는 회원 ID, 이름, 신용카드 정보, 계좌정보, A 포인트
                정보, 생년월일(결제 방식에 따른 정보 수집)
              </td>
            </tr>
            <tr>
              <td>상품 배송</td>
              <td>이름, 주소, 집 전화번호 또는 휴대폰</td>
            </tr>
            <tr>
              <td>현금 영수증 발급 (현금 영수증 발급 신청 시)</td>
              <td>휴대폰 번호</td>
            </tr>
          </tbody>
        </table>
      </div>
      <dl class="personal_comm">
        <dt>(공통) 이용&#183;보유기간</dt>
        <dd>
          계약 또는 청약철회 등에 관한 기록 5년<br />대금결제 및 재화 등의
          공급에 관한 기록 5년
          <span class="person_txt"
            >* 개인정보 수집 및 이용에 대한 동의를 거부하실 수 있으나, 거부 시
            상품의 구매, 대금 결제, 배송이 제한됩니다.</span
          >
        </dd>
      </dl>
    </div>
    <div class="align-box size-auto">
      <button type="button" class="btn-modal_close" @click="onDispose">
        확인
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupPrivacyConsent",
  methods: {
    onDispose() {
      this.$emit("dispose", "get out!");
    },
  },
};
</script>

<style>
</style>
